import {
  ButtonControl,
  CarRegistrationNumberControl,
  OptionalCarRegistrationNumberControl,
  VinControl,
  CheckboxControl,
  DateListControl,
  DateControl,
  EMailControl,
  InputControl,
  ListControl,
  MileageControl,
  NoneControl,
  NumberControl,
  PasswordControl,
  PeselControl,
  PhoneNumberControl,
  NipNumberControl,
  RadioGroupControl,
  VehicleTypeControl,
  DropdownControl,
  ZipCodeMaskedControl,
  CheckboxGroupControl,
  DocumentsControl,
  HouseNumberControl,
  LargeRadioGroup,
  NameControl,
  LastNameControl,
  StreetNameControl,
  InsurersListControl,
  PolicyNumberControl,
  SkpNumberControl,
  EurobandCarRegistrationNumberControl,
  PromotionCodeControl,
  InlineRadioGroupControl,
  LargeRadioWithIconControl,
  MotorcycleVinControl,
  CarRegistrationNumberButtonControl,
  CarRegistrationNumberReadonlyControl,
  VinNumberReadonlyControl,
  AutocompleteControl,
} from 'app/components/Controls';

export const defaultFormControls = {
  AUTOCOMPLETE: AutocompleteControl,
  LIST: ListControl,
  DATE_LIST: DateListControl,
  DATE: DateControl,
  CHECKBOX: CheckboxControl,
  GROUPED_CHECKBOX: CheckboxControl,
  CHECKBOX_GROUP: CheckboxGroupControl,
  SMALL_CHECKBOX_GROUP: CheckboxGroupControl,
  LIST_WITH_ADDITIONAL_INFO: LargeRadioGroup,
  LARGE_RADIO_WITH_ICON: LargeRadioWithIconControl,
  RADIO: RadioGroupControl,
  RADIO_ROW: InlineRadioGroupControl,
  TEXT: InputControl,
  CAR_VIN: VinControl,
  MOTORCYCLE_VIN: MotorcycleVinControl,
  MILEAGE: MileageControl,
  NUMBER: NumberControl,
  PESEL: PeselControl,
  PHONE_NUMBER: PhoneNumberControl,
  NIP_NUMBER: NipNumberControl,
  CAR_REGISTRATION_NUMBER: CarRegistrationNumberControl,
  OPTIONAL_CAR_REGISTRATION_NUMBER: OptionalCarRegistrationNumberControl,
  CAR_LONG_REGISTRATION_NUMBER: CarRegistrationNumberControl,
  ZIP_CODE: ZipCodeMaskedControl,
  HOUSE_NUMBER: HouseNumberControl,
  NAME: NameControl,
  STREETNAME: StreetNameControl,
  BUTTON: ButtonControl,
  EMAIL: EMailControl,
  PASSWORD: PasswordControl,
  SELECT: DropdownControl,
  NONE: NoneControl,
  LASTNAME: LastNameControl,
  DOCUMENTS: DocumentsControl,
  VEHICLE_TYPE: VehicleTypeControl,
  INSURERS_LIST: InsurersListControl,
  POLICY_NUMBER: PolicyNumberControl,
  SKP_NUMBER: SkpNumberControl,
  EUROBAND_CAR_REGISTRATION_NUMBER: EurobandCarRegistrationNumberControl,
  CAR_REGISTRATION_NUMBER_READONLY: CarRegistrationNumberReadonlyControl,
  CAR_VIN_READONLY: VinNumberReadonlyControl,
  PROMOTION_CODE: PromotionCodeControl,
  REGISTRATION_NUMBER_BUTTON: CarRegistrationNumberButtonControl,
};
